import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(true); // Default to dark theme

  const colors = {
    light: {
      background: '#f5f5f5',
      surface: 'white',
      text: '#2c3e50',
      border: '#e2e8f0',
      button: '#e2e8f0',
      buttonText: '#1a202c',
      positiveScore: '#38a169',
      negativeScore: '#e53e3e',
      overlay: 'rgba(0, 0, 0, 0.7)',
    },
    dark: {
      background: '#1a202c',
      surface: '#2d3748',
      text: '#e2e8f0',
      border: '#4a5568',
      button: '#2d3748',
      buttonText: '#e2e8f0',
      positiveScore: '#48bb78',
      negativeScore: '#f56565',
      overlay: 'rgba(0, 0, 0, 0.8)',
    }
  };

  const theme = {
    isDark,
    toggleTheme: () => {
      setIsDark(!isDark);
      localStorage.setItem('darkMode', !isDark);
    },
    colors: isDark ? colors.dark : colors.light
  };

  // Load theme preference from localStorage
  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme !== null) {
      setIsDark(savedTheme === 'true');
    }
  }, []);

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
